import Sidebar from "../../sidebar";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  getIn,
  FormikHelpers,
} from "formik";
import * as Yup from "yup";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import FormInput from "../../../../components/FormInput";
import { useEffect, useState } from "react";
import {
  addSampleProduct,
  getSampleProduct,
  updateSampleProduct,
} from "./form-section.service";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { validationSchema } from "./validation";
import FormSelect from "../../../../components/FormSelect";
import { getSampleCategories } from "../../sample-categories/sample-categories-section.service";
import FileUploaderMultiple from "../../../../components/FileUpload";

export default function FormSection({ isEdit }: { isEdit: boolean }) {
  const [product, setProduct] = useState<any>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const param = useParams();

  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    let formData = new FormData();
    formData.append("name", values.name);
    formData.append("code", values.code);
    // formData.append("quantity", values.quantity);
    // formData.append("itemFinish", values.itemFinish);
    // formData.append("locationName", values.locationName);
    formData.append("category", values.category.id);
    formData.append("centimeter", JSON.stringify(values.centimeter));
    formData.append("inch", JSON.stringify(values.inch));

    values.images.forEach((image: any, index: number) => {
      if (image instanceof File) {
        formData.append(`images`, image);
      } else {
        formData.append(`images`, image.key);
      }
    });

    if (isEdit) {
      updateSampleProduct(param.id as string, formData)
        .then((response) => {
          toast.success("Sample product updated successfully.");
          navigate("/admin/sample-products");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } else {
      addSampleProduct(formData)
        .then((response) => {
          toast.success("Sample product added successfully.");
          navigate("/admin/sample-products");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    }
  };

  const createImageURL = (key: string) => {
    return `https://d1gdand68muq63.cloudfront.net/sample-products/96/${key}`;
  };

  useEffect(() => {
    if (isEdit && param.id) {
      getSampleProduct(param.id).then((response) => {
        const images = response.data.images.map((image: any) => ({
          url: createImageURL(image.key),
          key: image.key,
          file: null,
        }));

        response.data.images = images;
        response.data.category = {
          id: response.data?.category?.id,
          name: response.data?.category?.name,
        };
        setProduct(response.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Add Sample Product</h5>
              </div>
              <div className="ec-vendor-card-body">
                {loading ? (
                  "Loading..."
                ) : (
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      name: product ? product.name : "",
                      code: product ? product.code : "",
                      quantity: product ? product.quantity : "",
                      itemFinish: product ? product.itemFinish : "",
                      locationName: product ? product.locationName : "",
                      category: product ? product.category : "",
                      centimeter: {
                        length: product ? product.centimeter.length : "",
                        width: product ? product.centimeter.width : "",
                        height: product ? product.centimeter.height : "",
                      },
                      inch: {
                        length: product ? product.inch.length : "",
                        width: product ? product.inch.width : "",
                        height: product ? product.inch.height : "",
                      },
                      images: product ? product.images : [],
                    }}
                    onSubmit={handleSubmit}
                  >
                    {({
                      handleChange,
                      handleBlur,
                      errors,
                      values,
                      touched,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <Form className="add_product_form">
                        <div className="row">
                          <div className="col-lg-12">
                            <FileUploaderMultiple
                              setFiles={(files: any) => {
                                console.log(files);
                                setFieldValue("images", [
                                  ...values.images,
                                  ...files,
                                ]);
                              }}
                              removeFile={(file: { key: any }) => {
                                const uploadedFiles = values.images;
                                const filtered = uploadedFiles.filter(
                                  (i: { key: any }) => i.key !== file.key
                                );
                                setFieldValue("images", [...filtered]);
                              }}
                              files={values.images}
                              folder="sample-products"
                            />
                            <div className="invalid-feedback d-block">
                              {getIn(errors, "images")}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <FormInput
                              label="Product Code"
                              placeholder="Product Code"
                              name="code"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.code}
                              error={getIn(errors, "code")}
                              touched={getIn(touched, "code")}
                              autoFocus
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-6">
                            <FormInput
                              label="Product Name"
                              placeholder="Product Name"
                              name="name"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                              error={getIn(errors, "name")}
                              touched={getIn(touched, "name")}
                              isRequired={false}
                              className={""}
                            />
                          </div>

                          <div className="col-lg-6">
                            <FormSelect
                              label="Category"
                              name="category"
                              margin="0"
                              isAsync
                              // options={sampleCategories}
                              getOptions={getSampleCategories}
                              getOptionLabel={(option: { name: any }) =>
                                option.name
                              }
                              getOptionValue={(option: { id: any }) =>
                                option.id
                              }
                              onChange={(name: string, value: any) => {
                                setFieldValue(name, value);
                              }}
                              value={values.category}
                              error={getIn(errors, "category")}
                              touched={getIn(touched, "category")}
                            />
                          </div>
                          <div className="default-form-box col-lg-12">
                            <label>Size In Centimeter</label>
                          </div>

                          <div className="col-lg-4">
                            <FormInput
                              //  label="Quantity"
                              placeholder="Length"
                              name="centimeter.length"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.centimeter.length}
                              error={getIn(errors, "centimeter.length")}
                              touched={getIn(touched, "centimeter.length")}
                              label={""}
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              // label="Quantity"
                              placeholder="Width"
                              name="centimeter.width"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.centimeter.width}
                              error={getIn(errors, "centimeter.width")}
                              touched={getIn(touched, "centimeter.width")}
                              label={""}
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              // label="Quantity"
                              placeholder="Height"
                              name="centimeter.height"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.centimeter.height}
                              error={getIn(errors, "centimeter.height")}
                              touched={getIn(touched, "centimeter.height")}
                              label={""}
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="default-form-box col-lg-12">
                            <label>Size In Inch</label>
                          </div>

                          <div className="col-lg-4">
                            <FormInput
                              //  label="Quantity"
                              placeholder="Length"
                              name="inch.length"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.inch.length}
                              error={getIn(errors, "inch.length")}
                              touched={getIn(touched, "inch.length")}
                              label={""}
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              // label="Quantity"
                              placeholder="Width"
                              name="inch.width"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.inch.width}
                              error={getIn(errors, "inch.width")}
                              touched={getIn(touched, "inch.width")}
                              label={""}
                              isRequired={false}
                              className={""}
                            />
                          </div>
                          <div className="col-lg-4">
                            <FormInput
                              // label="Quantity"
                              placeholder="Height"
                              name="inch.height"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.inch.height}
                              error={getIn(errors, "inch.height")}
                              touched={getIn(touched, "inch.height")}
                              label={""}
                              isRequired={false}
                              className={""}
                            />
                          </div>

                          <div className="col-lg-12">
                            <div className="text-right">
                              <button
                                className="btn btn-primary mr-1"
                                onClick={() => handleSubmit()}
                                type="button"
                              >
                                {isEdit
                                  ? "Save Sample Product"
                                  : " Add Sample Product"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
